import { DataPolicyColumnEffect } from '@vendia/management-api-types'
import { getPolicyEffectLabel } from 'src/utils/lakehouse/flows'

export type ProductColumnPoliciesProps = {
  columnPolicies: any[]
  defaultColumnPolicyEffect: DataPolicyColumnEffect
  allowAll?: boolean
  excludeAll?: boolean
}

export const ProductColumnPolicies = ({
  allowAll,
  excludeAll,
  defaultColumnPolicyEffect,
  columnPolicies,
}: ProductColumnPoliciesProps) => {
  const hasRules = columnPolicies.length > 0

  return (
    <>
      {(allowAll || excludeAll) && (
        <div>
          <strong>{allowAll ? 'Enable' : 'Exclude'}</strong> all columns by default
        </div>
      )}
      {hasRules &&
        columnPolicies
          // Don't include rules that match the default policy
          .filter((p) => p.effect !== defaultColumnPolicyEffect)
          .map((columnPolicy) => {
            return (
              <div key={columnPolicy.name}>
                <strong>{columnPolicy.name}:</strong>{' '}
                {getPolicyEffectLabel(columnPolicy.effect, defaultColumnPolicyEffect)?.toLowerCase()}
                {columnPolicy.value ? (
                  <>
                    {' '}
                    <span>{columnPolicy.value}</span>
                  </>
                ) : null}
                {columnPolicy.value && columnPolicy.effect === DataPolicyColumnEffect.MaskExceptLast ? ' chars' : null}
              </div>
            )
          })}
    </>
  )
}
